import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';

import rootReducer from './modules';

const enhancers = [
    applyMiddleware(thunkMiddleware)
];

// Enable redux dev tools only in development
const composeEnhancers = (process.env.NODE_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const configureStore = (initialState = {}) => {
    const enhancer = composeEnhancers(...enhancers);
    const store = createStore(rootReducer, initialState, enhancer);
    return store;
}

export default configureStore;



// WEBPACK FOOTER //
// ./src/configureStore.js